import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt: string | null;
  tags: string | null;
  featured_image_url: string | null;
  published_at: string | null;
  created_by: string;
  created_by_name: string;
  created_at: string;
  updated_at: string;
  is_published: boolean;
}

export interface CreateBlogPostInput {
  title: string;
  content: string;
  excerpt?: string;
  tags?: string[];
  featured_image_url?: string;
  is_published?: boolean;
}

export interface UpdateBlogPostInput {
  title?: string;
  content?: string;
  excerpt?: string;
  tags?: string[];
  featured_image_url?: string;
  is_published?: boolean;
}

// Public endpoints (no auth)
export async function getPublishedPosts(): Promise<BlogPost[]> {
  const response = await axios.get(`${API_BASE_URL}/blog/public`);
  return response.data.data;
}

export async function getPostBySlug(slug: string): Promise<BlogPost> {
  const response = await axios.get(`${API_BASE_URL}/blog/public/${slug}`);
  return response.data.data;
}

export async function getAllTags(): Promise<string[]> {
  const response = await axios.get(`${API_BASE_URL}/blog/public/tags`);
  return response.data.data;
}

// Admin endpoints (require auth)
export async function getAllPosts(token: string): Promise<BlogPost[]> {
  const response = await axios.get(`${API_BASE_URL}/blog`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function getPost(id: string, token: string): Promise<BlogPost> {
  const response = await axios.get(`${API_BASE_URL}/blog/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function createBlogPost(data: CreateBlogPostInput, token: string): Promise<BlogPost> {
  const response = await axios.post(`${API_BASE_URL}/blog`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function updateBlogPost(id: string, data: UpdateBlogPostInput, token: string): Promise<BlogPost> {
  const response = await axios.put(`${API_BASE_URL}/blog/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
}

export async function deleteBlogPost(id: string, token: string): Promise<void> {
  await axios.delete(`${API_BASE_URL}/blog/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
